import { render } from "./tegsoftNavTabs.vue?vue&type=template&id=2dd33229"
import script from "./tegsoftNavTabs.vue?vue&type=script&lang=js"
export * from "./tegsoftNavTabs.vue?vue&type=script&lang=js"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__